module.exports = __webpack_public_path__ + "img/c2.14c14eb5.svg";